import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITroubleshootIssueService = ( createDecorator('ITroubleshootIssueService'));
export { ITroubleshootIssueService };
